import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=c33169a6&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=c33169a6&prod&lang=sass"
import style1 from "./UserCard.vue?vue&type=style&index=1&id=c33169a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33169a6",
  null
  
)

export default component.exports